export const MOBILE_MATERIAL_BG_DARK = '#3A3444';
export const MOBILE_MATERIAL_BG_LIGHT = '#FFFFFF';
// Single styles component for materials responsive page
export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  const primary = theme?.palette?.primary?.main ?? '#5B35A5';
  const darkSurface = '#3A3444';
  const whiteSurface = '#FFFFFF';
  const darkPageBg = '#231F29';
  const headerTitleColor = isDark ? '#FFFFFF' : '#000000DE !important';
  const headerActionColor = isDark ? '#AFADB3' : '#807E84';
  const headerActionBg = isDark ? '#494453' : '#F6F6F7';
  const headerIconBg = isDark ? '#D0BCFA' : primary;
  const headerIconColor = isDark ? '#121212' : '#FFFFFF';
  const downArrowButtonBg = isDark ? '#000000' : '#EAE8ED';
  const listBorderColor = isDark ? '#F8F7F929' : '#231F2929';
  const nestedPageBg = isDark ? darkSurface : whiteSurface;
  const nestedPageHoverBg = isDark ? 'rgb(0, 0, 0)' : '#EAE8ED';
  const nestedPageActiveBg = isDark ? '#453F52' : '#F1EEF6';
  const hoverBgColor = isDark ? '#33313A' : '#EEEDEF';
  const aulaEditorPlaceholderBg = isDark ? '#231F29' : '#F8F7F9';
  const discussionSectionBorder = isDark ? '#D0BCFA' : '#8364C8';
  const discussionColors = isDark
    ? {
        accent: '#D0BCFA',
        border: '#837998',
        bg: '#363636',
      }
    : {
        accent: '#452188',
        border: '#A290C3',
        bg: '#FFFFFF',
      };
  const successBtn = '#2E7D32';
  const successBtnHover = '#1B5E20';
  const checkCircleBgDark = '#66BB6A';

  return {
    root: {
      display: 'flex',
      width: '100%',
      overflowY: 'hidden',
      height: '100%',
      boxSizing: 'border-box',
      overflowX: 'hidden',
      backgroundColor: isDark ? darkPageBg : '#F8F7F9',
    },
    mobilePage: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      flex: 1,
      height: '100%',
      minHeight: 0,
      overflow: 'hidden',
      backgroundColor: isDark ? darkPageBg : '#F8F7F9',
    },
    desktopShell: {
      display: 'flex',
      width: '100%',
      flex: '1',
      boxSizing: 'border-box',
    },
    leftSideMenu: {
      width: { md: '360px' },
      flexShrink: 0,
      display: 'flex',
      height: '100%',
    },
    indexArea: {
      flex: 1,
      minWidth: 0,
      display: 'flex',
    },
    indexShell: {
      width: '100%',
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflowY: 'auto',
      marginBottom: { xs: '1rem', md: '0' },
    },
    backButtonWrapperStyle: {
      marginLeft: '-8px',
      marginBottom: '1rem',
      pt: { xs: '16px', sm: '16px', md: '0' },
      px: { xs: '1rem', md: '0px' },
    },
    leftMenuPage: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      flex: 1,
      height: '100%',
      minHeight: 0,
      backgroundColor: isDark ? darkPageBg : '#F8F7F9',
    },
    leftMenuContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      flex: 1,
      boxSizing: 'border-box',
      height: '100%',
      minHeight: 0,
      p: '0.75rem',
      backgroundColor: isDark ? darkSurface : '#FFFFFF',
      borderRadius: 0,
      borderTop: `1px solid ${isDark ? '#2E2A36' : '#ECE8F3'}`,
      borderRight: `1px solid ${isDark ? '#2E2A36' : '#ECE8F3'}`,
      borderBottom: 0,
      borderLeft: 0,
    },
    menuHeader: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: { xs: '8px', md: '16px' },
      pt: { xs: '12px', sm: '12px', md: '0px' },
      width: '100%',
    },
    menuHeaderText: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minWidth: 0,
    },
    menuHeaderTitleRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: { xs: '8px', md: '11px' },
      minWidth: 0,
      width: '100%',
    },
    menuHeaderDivider: {
      mt: '1rem',
    },
    noResultsCardWrapper: {
      mt: { xs: '12px', sm: '12px', md: '16px' },
      mx: { xs: '16px', sm: '16px', md: '0px' },
    },
    noResultsCard: {
      width: '100%',
      height: { xs: 'auto' },
      gap: '4px',
      borderRadius: theme?.shape?.borderRadius ?? 2,
      bgcolor: isDark ? '#231F29' : '#F8F7F9',
      pt: { xs: '12px', sm: '12px', md: '16px' },
      px: { xs: '16px', sm: '16px', md: '16px' },
      pb: { xs: '12px', sm: '12px', md: '16px' },
      opacity: 1,
      boxSizing: 'border-box',
    },
    noResultsCardTitle: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontSize: '1rem',
      lineHeight: '175%',
      letterSpacing: '0.15px',
      color: 'text.primary',
      textAlign: 'center',
    },
    noResultsCardDescription: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontSize: '0.875rem',
      lineHeight: '143%',
      letterSpacing: '0.17px',
      textAlign: 'center',
      color: 'text.secondary',
      whiteSpace: 'pre-line',
    },
    menuHeaderLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: '11px',
      flexDirection: 'row',
      minWidth: 0,
      flex: 1,
      width: '100%',
    },
    menuHeaderIconWrap: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: headerIconBg,
      flexShrink: 0,
      color: headerIconColor,
    },
    menuHeaderTitle: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 600,
      fontStyle: 'normal',
      fontSize: '1.25rem',
      lineHeight: '160%',
      letterSpacing: '0px',
      flexShrink: 1,
      minWidth: 0,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: headerTitleColor,
    },
    menuHeaderActions: {
      display: 'flex',
      alignItems: 'center',
      gap: { xs: '8px', md: '11px' },
      flexShrink: 0,
    },
    menuHeaderActionButton: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      color: headerActionColor,
      border: 'none',
      padding: 0,
      minWidth: 0,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: headerActionBg,
      },
      '&.Mui-focusVisible': {
        backgroundColor: headerActionBg,
      },
    },
    menuList: {
      flex: 1,
      minHeight: 0,
      p: '0',
      overflowY: 'auto',
      scrollBehavior: 'smooth',
      paddingBottom: '1rem',
    },
    menuListItem: {
      mb: '8px',
    },
    menuItem: (active: boolean) => ({
      width: '100%',
      textAlign: 'left',
      font: 'inherit',
      cursor: 'pointer',
      border: 'none',
      backgroundColor: 'transparent',
      color: active ? primary : 'inherit',
    }),
    menuItemTitle: {
      fontWeight: 600,
      fontSize: '1rem',
    },
    indexContainer: {
      flex: { md: 1 },
      width: '100%',
      minWidth: 0,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      py: { md: '40px' },
      // For desktops : viewport height - header height
      // For mobile :  viewport height - (header height + back button header + extra padding)
      height: {
        xs: 'calc(100dvh - 144px)',
        sm: 'calc(100dvh - 152px)',
        md: 'calc(100vh - 64px)',
      },
      pt: { md: '40px' },
      pb: { md: '1rem' },
      px: { xs: '1rem', sm: '1rem', md: '1.5rem', xl: '192px' },
      backgroundColor: isDark ? darkPageBg : '#F8F7F9',
      boxSizing: 'border-box',
    },
    indexPanel: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      boxSizing: 'border-box',
      backgroundColor: isDark ? darkPageBg : '#F8F7F9',
    },
    indexBody: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      flex: 1,
      minHeight: 0,
    },
    indexEmptyState: {
      width: '100%',
      minHeight: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: { xs: '1rem', sm: '1rem', md: '1.5rem', xl: '192px' },
      boxSizing: 'border-box',
    },
    sectionContainer: {
      overflowY: 'auto',
      overflowX: 'hidden',
      scrollbarGutter: 'stable',
      flex: 1,
      minHeight: 0,
      // xs/sm: 100vw minus indexContainer horizontal padding (1rem × 2 = 32px)
      // md:    100vw minus left sidebar (360px) minus indexContainer px (1.5rem × 2 = 48px)
      // xl:    100vw minus left sidebar (360px) minus indexContainer xl px (192px × 2 = 384px)
      width: {
        xs: 'calc(100vw - 32px)',
        md: 'calc(100vw - 408px)',
        xl: 'calc(100vw - 744px)',
      },
      padding: { xs: '15px', sm: '24px' },
      borderRadius: '12px',
      backgroundColor: isDark ? darkSurface : '#FFFFFF',
      border: `1px solid ${isDark ? '#2E2A36' : '#ECE8F3'}`,
      color: isDark ? '#FFFFFF' : '#26222C',
      boxSizing: 'border-box',
    },
    discussionActivitySection: {
      mt: '24px',
      width: '100%',
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: { xs: 'stretch', sm: 'center' },
      justifyContent: 'space-between',
      gap: { xs: '8px', sm: '16px' },
      py: { xs: '10px', sm: '9px' },
      px: { xs: '16px' },
      borderRadius: '8px',
      backgroundColor: discussionColors.bg,
      border: `2px solid ${discussionSectionBorder}`,
      boxSizing: 'border-box',
    },
    discussionActivityTitle: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightMedium ?? 500,
      fontSize: '15px',
      lineHeight: '26px',
      letterSpacing: '0px',
      color: isDark ? '#FFFFFF' : '#26222C',
      flex: 1,
      minWidth: 0,
    },
    discussionActivityButton: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      width: { xs: '100%', sm: '180px' },
      py: { xs: '7px' },
      borderRadius: '8px',
      border: `1px solid ${discussionColors.border}`,
      backgroundColor: discussionColors.bg,
      color: discussionColors.accent,
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: '143%',
      letterSpacing: '0.15px',
      cursor: 'pointer',
      boxSizing: 'border-box',
      transition: 'background-color 120ms ease, border-color 120ms ease',
      '&:hover': {
        backgroundColor: theme?.palette?.action?.hover,
        borderColor: theme?.palette?.primary?.dark ?? discussionColors.accent,
      },
      '&:focus-visible': {
        backgroundColor: theme?.palette?.action?.hover,
        borderColor: theme?.palette?.primary?.dark ?? discussionColors.accent,
        outline: 'none',
      },
    },
    discussionActivityButtonIcon: {
      flexShrink: 0,
    },
    discussionActivityButtonText: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightMedium ?? 500,
      fontStyle: 'normal',
      fontSize: '0.9375rem',
      lineHeight: '26px',
      letterSpacing: '0px',
      color: discussionColors.accent,
      pointerEvents: 'none',
    },
    discussionTopicModalDialog: {
      width: { xs: 343, md: 560 },
      maxHeight: 'calc(100vh - 32px)',
      boxSizing: 'border-box',
      bgcolor: 'background.paper',
      borderRadius: '8px',
      boxShadow: isDark
        ? '0px 12px 28px rgba(0, 0, 0, 0.45)'
        : '0px 12px 28px rgba(34, 25, 53, 0.18)',
      p: { xs: 3, sm: 3, md: 3 },
      overflow: 'auto',
      outline: 'none',
    },
    discussionTopicModalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      mb: { xs: '12px', sm: '16px', md: '24px' },
      height: '44px',
      minHeight: '44px',
    },
    discussionTopicModalTitle: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.6,
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
      py: '0.25rem',
    },
    discussionTopicModalCloseButton: {
      flexShrink: 0,
      mr: '-0.25rem',
      color: theme?.palette?.text?.secondary,
    },
    discussionTopicModalDescription: {
      fontSize: '1rem',
      lineHeight: 1.8,
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
      mb: 2,
    },
    discussionTopicModalField: {
      marginTop: 0,
      '& .MuiInputBase-root': {
        minHeight: '48px',
      },
    },
    discussionTopicModalAction: {
      mb: '1.5rem',
    },
    discussionTopicModalActionRow: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'default',
    },
    discussionTopicModalCheckbox: {
      flexShrink: 0,
      m: 0,
      '&.MuiFormControlLabel-root': {
        ml: '-10px',
      },
    },
    discussionTopicModalActionLabel: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontStyle: 'normal',
      fontSize: '1rem',
      lineHeight: '180%',
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
      cursor: 'default',
    },
    discussionTopicModalFooter: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 1.5,
      flexWrap: 'wrap',
    },
    deletePageModalDialog: {
      width: { xs: 343, md: 560 },
      bgcolor: 'background.paper',
      borderRadius: '8px',
      boxSizing: 'border-box',
      p: '1.5rem',
      outline: 'none',
    },
    deletePageModalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
      mb: { xs: '12px', sm: '16px' },
      minHeight: { xs: '44px', sm: '40px' },
    },
    deletePageModalTitle: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.6,
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
      py: '0.25rem',
    },
    deletePageModalCloseButton: {
      color: theme?.palette?.grey?.[500] ?? theme?.palette?.text?.secondary,
      flexShrink: 0,
      mr: '-0.25rem',
    },
    deletePageModalBody: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontStyle: 'normal',
      fontSize: '1rem',
      color: theme?.palette?.text?.primary,
      mb: '1.5rem',
      lineHeight: '180%',
      letterSpacing: '0.15px',
    },
    deletePageModalBodyStrong: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightMedium ?? 500,
      fontStyle: 'normal',
      fontSize: '1rem',
      lineHeight: '150%',
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
    },
    deleteCommentModalBody: {
      mb: '1.5rem',
    },
    deleteCommentModalBodyPrimary: {
      fontFamily: theme?.typography?.fontFamily,
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      lineHeight: '180%',
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
    },
    deleteCommentModalBodySecondary: {
      fontFamily: theme?.typography?.fontFamily,
      fontSize: '0.875rem',
      fontStyle: 'normal',
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      lineHeight: '180%',
      letterSpacing: '0.17px',
      color: theme?.palette?.text?.secondary,
    },
    deletePageModalFooter: {
      display: 'flex',
      gap: '0.75rem',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    discussionTopicSection: {
      mt: '24px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      py: { xs: '10px', sm: '11px' },
      px: { xs: '16px' },
      borderRadius: '8px',
      backgroundColor: discussionColors.bg,
      border: `2px solid ${discussionSectionBorder}`,
      boxSizing: 'border-box',
    },
    discussionTopicSectionHidden: {
      position: 'relative',
      py: { xs: '14px' },
    },
    discussionTopicStatus: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      color: theme?.palette?.text?.secondary,
      minWidth: 0,
      width: 'fit-content',
    },
    discussionTopicStatusIcon: {
      flexShrink: 0,
      color: theme?.palette?.text?.disabled,
    },
    discussionTopicStatusText: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontSize: '14px',
      lineHeight: '150%',
      letterSpacing: '0.17px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'inline',
    },
    discussionStudentSection: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      boxSizing: 'border-box',
    },
    discussionStudentPrompt: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightMedium ?? 500,
      fontStyle: 'normal',
      fontSize: '1.25rem',
      lineHeight: '160%',
      letterSpacing: '0.15px',
      color: theme.palette?.text?.primary,
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      WebkitLineClamp: 3,
    },
    discussionStudentRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      minWidth: 0,
    },
    discussionStudentAvatar: {
      width: '40px',
      height: '40px',
    },
    discussionStudentPlaceholder: {
      flex: 1,
      minWidth: 0,
      width: '100%',
      height: '64px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '4px',
      backgroundColor: aulaEditorPlaceholderBg,
      color: isDark ? '#FFFFFF' : '#5E5870',
      fontFamily: theme?.typography?.fontFamily,
      fontSize: '0.937rem',
      lineHeight: '26px',
      textAlign: 'center',
      padding: '0 12px',
      boxSizing: 'border-box',
    },
    discussionTopicHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '29px',
      minWidth: 0,
    },
    discussionTopicHeaderHidden: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '29px',
      minWidth: 0,
      paddingRight: '48px',
    },
    discussionTopicValue: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightMedium ?? 500,
      fontSize: '0.9375rem',
      lineHeight: '26px',
      letterSpacing: '0px',
      color: isDark ? '#FFFFFF' : 'rgba(0, 0, 0, 0.87)',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      WebkitLineClamp: 2,
      flex: 1,
      minWidth: 0,
    },
    discussionTopicEditButton: {
      flexShrink: 0,
      mt: '-2px',
    },
    discussionTopicEditButtonHidden: {
      position: 'absolute',
      right: '16px',
      top: '50%',
      transform: 'translateY(-50%)',
      flexShrink: 0,
      mt: 0,
    },
    indexText: {
      fontWeight: 400,
      lineHeight: 1.7,
      color: isDark ? '#FFFFFF' : '#26222C',
      mb: '16px',
    },
    singlePageMaterial: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: `1px solid ${listBorderColor}`,
      borderRadius: '0.5rem',
      minHeight: '48px',
      height: '48px',
      p: '0.75rem 0.5rem',
      cursor: 'pointer',
      mb: '0.75rem',
      lineHeight: '150%',
      backgroundColor: theme.palette.background.default,
      '&.selected': {
        backgroundColor: theme?.palette?.action?.selected,
        borderColor: primary,
      },

      [theme.breakpoints.up('md')]: {
        '&:hover': {
          backgroundColor: hoverBgColor,
          '.visibility-toggle': {
            display: 'inline-flex',
          },
        },
      },
    },
    nestedPageMaterial: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      minHeight: '48px',
      height: '48px',
      borderBottom: `1px solid ${listBorderColor}`,
      p: '0.75rem 0.5rem 0.75rem 1rem !important',
      cursor: 'pointer',
      backgroundColor: nestedPageBg,
      lineHeight: '150%',
      '&.selected': {
        backgroundColor: nestedPageActiveBg,
      },
      [theme.breakpoints.up('md')]: {
        '&:hover': {
          backgroundColor: nestedPageHoverBg,
          '.visibility-toggle': {
            display: 'inline-flex',
          },
        },
      },
    },
    addNewPage: {
      display: 'flex',
      alignItems: 'center',
      height: '48px',
      padding: '0.375rem 0.5rem !important',
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 600,
      fontSize: '0.875rem',
      cursor: 'pointer',
      backgroundColor: nestedPageBg,
      borderRadius: ' 0 0 0.5rem 0.5rem',
      '&:hover': {
        backgroundColor: nestedPageHoverBg,
      },
    },
    materialTitle: {
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      fontFamily: theme?.typography?.fontFamily,
      fontSize: '0.875rem',
      letterSpacing: '0.17px',
      lineHeight: '150%',
      minWidth: 0,
      wordBreak: 'break-word',
    },
    accordion: {
      marginBottom: '0.75rem',
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${listBorderColor}`,
      borderRadius: '0.5rem !important',
      '&.selected': {
        borderColor: primary,
      },
      '& .MuiAccordion-heading': {
        '&:hover': {
          '.visibility-toggle, .section-options': {
            display: 'inline-flex',
          },
        },
      },
      '& .MuiAccordionSummary-root': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: '0.5rem !important',
        height: '64px',
        maxHeight: '64px',
      },
      '&&.Mui-expanded': {
        margin: '0 0 0.75rem 0',
      },
      '& .MuiBox-root': { maxHeight: 'max-content' },
      '& .MuiAccordionDetails-root, .MuiBox-root': {
        p: 0,
      },
    },
    suffixIcons: {
      display: 'flex',
      marginRight: '0.5rem',
    },
    arrow: {
      color: primary,
    },
    downArrowButton: {
      backgroundColor: downArrowButtonBg,
    },
    addCircleIcon: {
      color: theme.palette.primary.main,
    },
    eyeIcon: {
      color: theme.palette.text.primary,
    },
    fileIcon: {
      color: theme.palette.action.active,
    },
    prefix: { display: 'flex', alignItems: 'center', gap: '0.5rem' },
    sectionListItemLastChild: {
      borderRadius: '0 0 0.5rem 0.5rem',
    },
    titleField: {
      minHeight: '3rem',
      '& .MuiInputBase-root': {
        position: 'relative',
        height: 'auto',
        minHeight: '3rem',
        alignItems: 'flex-start',
        padding: '12px',
        paddingRight: '44px',
      },
      '& .MuiInputAdornment-root': {
        position: 'absolute',
        right: '4px',
        top: '50%',
        transform: 'translateY(-50%)',
        height: 'auto',
        maxHeight: 'none',
      },
      '& .MuiInputLabel-root.MuiInputLabel-sizeSmall': {
        transform: 'translate(14px, 13px) scale(1)',
      },
      '& .MuiInputLabel-root.MuiInputLabel-shrink': {
        transform: 'translate(14px, -9px) scale(0.75)',
      },
    },
    title: {
      fontWeight: 600,
      color: headerTitleColor,
      fontSize: { xs: '1rem', md: '1.5rem' },
      lineHeight: '150%',
      letterSpacing: '0.15px',
    },
    aulaEditorWrapper: {
      pt: 0,
      mt: 0,
      width: '100%',
      display: 'flex',
      flex: '1',
      minHeight: '0',
      flexDirection: 'column',
      fontFamily: theme?.typography?.fontFamily,
      fontSize: '0.937rem',
      lineHeight: '26px',
      overflowX: 'hidden',
      '& [class*="focusOutline"]': {
        pt: '0',
        mt: '1rem',
        minHeight: '100px',
        paddingLeft: '4px',
        // To remove dark border at the top of the editor when focused
        outline: 'none',
        '&:focus-within, &:focus-visible': {
          outline: 'none',
          boxShadow: 'none',
          borderColor: 'transparent',
        },
        // Apply the theme font only to normal text spans, leaving latex
        // (katex) and code block spans with their own fonts untouched.
        'span:not([data-testid="latex-syntax"] span):not([data-testid="code-block"] span):not(.katex):not(.katex span):not(code span)':
          {
            fontFamily: theme?.typography?.fontFamily,
          },
      },
      // To remove dark border at the top of the editor when focused
      '& [data-testid="block-toolbar"]': {
        right: '2rem !important',
      },
      '& [data-slate-node="element"]': {
        width: '100% !important',
      },
    },
    materialViewSkeleton: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      width: '100%',
      minWidth: 0,
      overflow: 'hidden',
      padding: { xs: '1rem', md: '0 0 0 1.5rem' },
      boxSizing: 'border-box',
    },
    aulaPlaceholder: {
      p: '1rem',
      width: '100%',
      display: 'flex',
      flex: '1',
      minHeight: '0',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: aulaEditorPlaceholderBg,
      fontFamily: theme?.typography?.fontFamily,
      fontSize: '0.937rem',
      lineHeight: '26px',
    },
    closeIcon: {
      display: 'none',
      '.Mui-focused &': { display: 'flex' },
    },
    readonlyActionBar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'end',
      mb: '16px',
    },
    readonlyActionBarBtn: {
      height: '36px',
    },
    stepsCompleted: {
      backgroundColor: successBtn,
      color: theme.palette.common.white,
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: successBtnHover,
      },
    },
    stepCompletedHoverMobile: {
      '&:hover': {
        backgroundColor: successBtn,
      },
    },
    readonlyActionBarBtnHover: {
      '&:hover': {
        border: '1px solid !important',
      },
    },
    checkCircle: {
      color: isDark ? checkCircleBgDark : successBtn,
      fontSize: '24px',
    },
    editableSectionContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
    },
    actionBarContainer: { flexShrink: 0 },
    editableContent: {
      overflowY: 'auto',
      flex: 1,
      minHeight: 0,
      pr: '1rem',
    },
    progressCount: {
      fontFamily: theme?.typography?.fontFamily,
      letterSpacing: '0',
      color: theme.palette.primary.main,
      fontWeight: 600,
      lineHeight: '160%',
    },
    progressCountWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexWrap: 'nowrap',
      gap: '0.5rem',
      alignItems: 'center',
      minWidth: 0,
      whiteSpace: 'nowrap',
    },
    infoIcon: {
      color: theme?.palette?.action?.active,
      fontSize: '20px',
      cursor: 'pointer',
    },
    iconButton: { width: '24px', height: '24px', marginLeft: '-0.25rem' },
    stepsCompletedCounter: {
      '&.MuiTypography-body1': {
        color: `${theme.palette.text.secondary} !important`,
        fontSize: '0.875rem !important',
        lineHeight: '143% !important',
      },
    },
    headerBox: { display: 'flex', flexDirection: 'column' },
    restoreDeletedPanelEditor: {
      backgroundColor: theme.palette.background.default,
      borderRadius: '8px',
      border: `1px solid ${theme.palette.divider}`,
      px: '16px',
      overflow: 'hidden',
      width: '100%',
      boxSizing: 'border-box',
      '& [class*="focusOutline"]': {
        // To remove dark border at the top of the editor when focused
        outline: 'none',
        '&:focus-within, &:focus-visible': {
          outline: 'none',
          boxShadow: 'none',
          borderColor: 'transparent',
        },
        // Apply the theme font only to normal text spans, leaving latex
        // (katex) and code block spans with their own fonts untouched.
        'span:not([data-testid="latex-syntax"] span):not([data-testid="code-block"] span):not(.katex):not(.katex span):not(code span)':
          {
            fontFamily: theme?.typography?.fontFamily,
          },
        // To remove dark border at the top of the editor when focused
        '& [data-testid="spacer"]': {
          background: 'none',
        },
        '& [data-testid="block-link-youtube"]': {
          width: { xs: '100% !important', md: '376px !important' },
        },
        '& div:has(> .katex-display)': {
          maxWidth: 'calc(100% - 140px)',
          overflow: 'auto',
        },
        '& .katex-display > .katex': {
          whiteSpace: 'normal',
          textAlign: 'start',
        },
        '& .katex .base': {
          whiteSpace: 'normal',
          width: 'auto',
          maxWidth: '100%',
          display: 'inline',
        },
        '& [data-testid="latex-syntax"], & .katex-syntax': {
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
          textAlign: 'start',
        },
        '& [data-testid="code-block"] pre span[data-slate-string="true"]': {
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
        },
      },
    },
    spaceInfoWrapper: {
      mt: '1.5rem',
    },
    spaceTitle: {
      display: '-webkit-box !important',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden !important',
      fontSize: '1.25rem',
      lineHeight: '160%',
      letterSpacing: '0.15px',
      fontWeight: 500,
      color: theme.palette.text.secondary,
      fontFamily: theme?.typography?.fontFamily,
    },
    parentFolderTitle: {
      display: '-webkit-box !important',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden !important',
      mt: '0.5rem',
      fontSize: '0.75rem',
      fontWeight: 600,
      letterSpacing: '1px',
      color: theme.palette.text.secondary,
      fontFamily: theme?.typography?.fontFamily,
    },
    divider: {
      mt: '1rem',
      mb: '1rem',
    },
  };
};
